module.exports = __webpack_public_path__ + "static/media/fermer.c7de51cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/apps/tunnel/components/@sharded/notifications/fermer.svg
// module id = 548
// module chunks = 0